<template>
  <div>
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>

    <v-expansion-panel
      :value="openedPanel"
      class="pa-2"
      v-if="ticketList.length > 0"
    >
      <v-expansion-panel-content
        class="mt-2 elevation-3"
        v-for="(item, i) in ticketList"
        :key="i"
        lazy
        readonly
        hide-actions
      >
        <template v-slot:header>
          <div>
            <!-- AKTARMALI GIDIS DONUS UCUSLARI 6 KAYIT -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 6"
              v-for="(ticketInside, k) in item.FlightSegments"
              :key="k"
            >
              <v-flex xs12 sm12 md12>
                <v-layout row wrap v-if="k == 0 || k == 4">
                  <v-flex xs12 sm4 md3 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[k].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md3>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ item.FlightSegments[k].DepartureTime }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[k].DepartureAirportName }} ({{
                            item.FlightSegments[k].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                  <v-flex xs12 sm4 md2>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[k + 1].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[k + 1].ArrivalAirportName }}
                          ({{
                            item.FlightSegments[k + 1].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-show="k == 0"
                  >
                  <!-- {{item.PricingInfo.Currency}} -->
                    <span class="headline">{{ item.TotalFare }}  </span>
                  </v-flex>

                  <v-flex
                    xs12
                    sm2
                    md2
                    class="my-auto text-xs-center"
                    v-show="item.FlightSegments.length == k + 2"
                  >
                    <v-btn
                      v-if="isActive"
                      color="success"
                      @click="openPanel(i, 1, true)"
                      >SEC</v-btn
                    >
                    <v-btn v-else color="success" @click="openMailDialog()"
                      >SEC</v-btn
                    >
                  </v-flex>

                  <v-flex xs12 sm12 md10>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="k == 4">
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMALI GIDIS DONUS UCUSLARI -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 4"
              v-for="(ticketInside, k) in item.FlightSegments"
              :key="k"
            >
              <v-layout row wrap v-if="k == 0 || k == 2">
                <v-flex xs12 sm4 md3 class="my-auto">
                  <v-img
                    :src="getImgUrl(item.FlightSegments[k].OperatingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[k].DepartureTime }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.FlightSegments[k].DepartureAirportName }} ({{
                          item.FlightSegments[k].DepartureAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.FlightSegments[k + 1].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.FlightSegments[k + 1].ArrivalAirportName }} ({{
                          item.FlightSegments[k + 1].ArrivalAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="k == 0"
                >
                <!-- {{item.PricingInfo.Currency}} -->
                  <span class="headline">{{ item.TotalFare }}  </span>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="item.FlightSegments.length == k + 2"
                >
                  <v-btn
                    v-if="isActive"
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  >
                </v-flex>

                <v-flex xs12 sm12 md10>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12 md12 v-if="k == 2">
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMASIZ GIDIS DONUS UCUSLARI  -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 2 && FlightType == 'RT'"
              v-for="(ticketInside, l) in item.FlightSegments"
              :key="l"
            >
              <v-layout row wrap xs12 sm12 md12>
                <v-flex xs12 sm4 md3 class="my-auto">
                  <v-img
                    :src="getImgUrl(item.FlightSegments[l].OperatingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[l].DepartureTime }} a
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.FlightSegments[l].DepartureAirportName }} ({{
                          item.FlightSegments[l].DepartureAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.FlightSegments[l].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.FlightSegments[l].ArrivalAirportName }} ({{
                          item.FlightSegments[l].ArrivalAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="l == 0"
                >
                <!-- {{item.PricingInfo.Currency}} -->
                  <span class="headline">{{ item.TotalFare }}  </span>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  class="my-auto text-xs-center"
                  v-show="item.FlightSegments.length == l + 1"
                >
                  <v-btn
                    v-if="isActive"
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  >
                </v-flex>

                <v-flex xs12 sm12 md10>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>

              <v-flex
                xs12
                sm12
                md12
                v-show="item.FlightSegments.length == l + 1"
              >
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMASIZ TEK YON UCUSLAR -->
            <v-layout
              row
              wrap
              v-if="item.FlightSegments.length == 1"
              v-for="(ticketInside, m) in item.FlightSegments"
              :key="m"
            >
              <v-layout row wrap xs12 sm12 md12>
                <v-flex xs12 sm4 md2 class="my-auto">
                  <v-img
                    :src="getImgUrl(item.FlightSegments[m].OperatingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[m].DepartureTime }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.FlightSegments[m].DepartureAirportName }} ({{
                          item.FlightSegments[m].DepartureAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.FlightSegments[m].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.FlightSegments[m].ArrivalAirportName }} ({{
                          item.FlightSegments[m].ArrivalAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                  <!-- {{item.PricingInfo.Currency}} -->
                  <span class="headline">{{ item.TotalFare }}  </span>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                  <v-btn
                    v-if="isActive"
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  >
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12 md12>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <!-- AKTARMALI TEK YON UCUSLAR -->
            <v-layout
              row
              wrap
              v-if="
                (item.FlightSegments.length == 2 && FlightType == 'OW') ||
                (item.FlightSegments.length == 3 && FlightType == 'OW')
              "
            >
              <v-layout row wrap xs12 sm12 md12>
                <v-flex xs12 sm4 md2 class="my-auto">
                  <v-img
                    :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                    alt="K"
                    height="35px"
                    width="85px"
                    contain
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >{{ item.FlightSegments[0].DepartureTime }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                          item.FlightSegments[0].DepartureAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm4 md2 class="my-auto subheading"> </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-list>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.FlightSegments[1].ArrivalTime
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ item.FlightSegments[1].ArrivalAirportName }} ({{
                          item.FlightSegments[1].ArrivalAirportCode
                        }})</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                  <!-- {{item.PricingInfo.Currency}} -->
                  <span class="headline">{{ item.TotalFare }}  </span>
                </v-flex>

                <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                  <v-btn
                    v-if="isActive"
                    color="success"
                    @click="openPanel(i, 1, true)"
                    >SEC</v-btn
                  >
                  <v-btn v-else color="success" @click="openMailDialog()"
                    >SEC</v-btn
                  >
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12 md12>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 sm4 md2>
                <v-chip color="green" text-color="white" small>{{
                  item.FlightSegments[0].CabinType
                }}</v-chip>
              </v-flex>

              <!-- AKTARMASIZ TEK YON UCUSLAR -->

              <v-flex xs12 sm4 md4 v-if="FlightType == 'OW'">
                <v-chip
                  color="blue"
                  text-color="white"
                  small
                  v-show="checkDirect(item.FlightSegments)"
                  >{{ $t("Direct") }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
              </v-flex>

              <!-- AKTARMALI TEK YON UCUSLAR -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 2"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  small
                  v-show="checkDirect(item.FlightSegments)"
                >
                  {{ $t("Direct") }}
                </v-chip>
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
              </v-flex>

              <!-- AKTARMALI GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 6"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  v-show="checkDirect(item.FlightSegments)"
                  small
                >
                  {{ $t("Direct") }}
                </v-chip>
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 5) }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  Dönüş aktarma:
                  {{ calculateTimediff(item.FlightSegments, 6) }}</v-chip
                >
              </v-flex>

              <!-- AKTARMALI GIDIS DONUS UCUSLARI -->

              <v-flex
                xs12
                sm4
                md4
                v-if="FlightType == 'RT' && item.FlightSegments.length == 4"
              >
                <v-chip
                  color="blue"
                  text-color="white"
                  v-show="checkDirect(item.FlightSegments)"
                  small
                >
                  {{ $t("Direct") }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  {{ $t("Transfer-Flight") }} :
                  {{ calculateTimediff(item.FlightSegments, 1) }}</v-chip
                >
                <v-chip
                  color="indigo"
                  text-color="white"
                  v-show="checkTransfer(item.FlightSegments)"
                  small
                >
                  Dönüş aktarma:
                  {{ calculateTimediff(item.FlightSegments, 2) }}</v-chip
                >
              </v-flex>

              <v-flex xs12 sm4 md2>
                <v-chip color="indigo" text-color="white" small
                  >Branded Fares / {{ item.FlightSegments[0].BookingClass }} /
                  {{ item.FlightSegments[0].ResBookDesigQuantity }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center">
                <v-btn
                  flat
                  small
                  class="my-0"
                  :disabled="!isActive"
                  @click="openPanel(i, 2, false)"
                >
                  {{ $t("Show-Details") }}
                </v-btn>
              </v-flex>
              <v-flex xs12 sm4 md2 class="my-auto text-xs-center">
                <v-btn
                  flat
                  small
                  class="my-0"
                  :disabled="!isActive"
                  @click="openPanel(i, 3, false)"
                >
                  Diğer Fiyatlar
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>

        <v-container
          v-if="cardView || tableView || otherPrices"
          fluid
          grid-list-xl
        >
          <v-layout row wrap justify-end>
            <v-flex v-if="cardView" xs6 sm2 md3 px-5>
              <v-text-field
                v-if="!isUpSell"
                outline
                :label="$t('Markup-Added-per-Person')"
                v-model="ticketMarkup"
                @keyup.enter="pickTicket(item)"
                @click:append="pickTicket(item)"
                append-icon="send"
              >
              </v-text-field>
              <v-text-field
                v-if="isUpSell"
                outline
                :label="$t('Markup-Added-per-Person')"
                v-model="ticketMarkup"
                @keyup.enter="pickTicket(upSellTicket)"
                @click:append="pickTicket(upSellTicket)"
                append-icon="send"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-start justify-space-between row fill-height>
            <v-flex xs12 sm12 md12 sm4 md4 v-if="tableView">
              <v-data-table
                :headers="headersSummary"
                :items="item.FlightSegments"
                class="elevation-1 mb-3"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.MarkettingAirline }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.FlightNumber }} -
                    {{ props.item.DepartureAirportCode }} -
                    {{ props.item.ArrivalAirportCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.DepartureDate) }} -
                    {{ props.item.DepartureTime }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.ArrivalDate) }} -
                    {{ props.item.ArrivalTime }}
                  </td>
                  <td class="text-xs-left">{{ props.item.EquipmentType }}</td>
                  <td class="text-xs-left">
                    {{ props.item.CabinType }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ResBookDesigQuantity }}
                  </td>
                </template>
              </v-data-table>

<div v-if="1==0">
  <v-data-table 
                :headers="headers"
                class="elevation-1"
                :items="item.SelectableFares"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeCode }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaseFare }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalTax }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.ServiceFee }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.PassengerTypeQuantity }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.BaggageAllowance }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.TotalFare }}
                  </td>
                </template>

                <template v-slot:footer>
                  <td>
                    <strong> {{ $t("Totals") }} </strong>
                  </td>
                  <td>
                    <strong>{{ calculateFooter(1, i) }}</strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(2, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(3, i) }} </strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(4, i) }} </strong>
                  </td>
                  <td>
                    <strong></strong>
                  </td>
                  <td>
                    <strong> {{ calculateFooter(5, i) }} </strong>
                  </td>
                </template>
              </v-data-table>
</div>
             


            </v-flex>
          </v-layout>
          <v-layout row wrap justify-end>
            <v-flex v-if="otherPrices" xs12 sm12 md12 px-5>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm4
                  md3
                  v-for="(itemPrices, indexPrices) in otherPricesList"
                  :key="indexPrices"
                >
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="(
                      itemPricesInfo, indexPricesInfo
                    ) in itemPrices.FlightSegments"
                    :key="indexPricesInfo"
                  >
                    <v-card>
                      <v-card-title>
                        <v-layout
                          row
                          wrap
                          align-center
                          justify-center
                          class="font-weight-medium title pa-2"
                        >
                        if (itemPricesInfo!=null)
                        {
                           {{ itemPricesInfo.CabinType }} -
                          {{ itemPricesInfo.PricingInfo.TotalFare }}
                          {{ itemPricesInfo.PricingInfo.Currency }}
                        }
                        else
                        {
                          {{  item.FlightSegments[0].CabinType }} -
                          {{ item.TotalFare }}
                          {{ item.SelectableFares[0].Currency }}
                        }

                        </v-layout>
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-layout row wrap align-center justify-center>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-for="(
                              itemFareBreakdown, indexFareBreakdown
                            ) in itemPricesInfo.PricingInfo.FareBreakdowns"
                            :key="indexFareBreakdown"
                          >
                            <v-flex
                              xs12
                              sm12
                              md12
                              v-for="(
                                itemAmenities, indexAmenities
                              ) in itemFareBreakdown.Amenities"
                              :key="indexAmenities"
                            >
                              <v-layout
                                row
                                wrap
                                align-center
                                justify-center
                                class="font-weight-medium body-1 pa-2"
                              >
                                {{ itemAmenities.Description }}
                              </v-layout>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-btn
                              block
                              color="primary"
                              @click="setUpSellTicket(itemPrices)"
                              dark
                              >Seç</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-layout row justify-center>
      <v-dialog v-model="dialogAds" persistent max-width="490">
        <v-card>
          <v-card-title class="headline primary white--text">
            Arkman - Sem Bilet
            <v-spacer></v-spacer>
            <v-btn flat icon color="primary" @click.native="dialogAds = false">
              <v-icon class="white--text">cancel</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <blockquote>
              Sem Bilet ile acentelik anlaşması yaparak bu hizmetten
              faydalanabilirsiniz. Sizinle iletişime geçilmesini ister misiniz ?
            </blockquote>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="openInfoDialog()">{{
              $t("OK")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialogUserInfo" persistent max-width="490">
        <v-card>
          <v-card-title class="headline primary white--text">
            Arkman - Sem Bilet
            <v-spacer></v-spacer>
            <v-btn
              flat
              icon
              color="primary"
              @click.native="dialogUserInfo = false"
            >
              <v-icon class="white--text">cancel</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form ref="userInfoForm">
              <v-text-field
                :label="$t('Username')"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userName"
              ></v-text-field>
              <v-text-field
                :label="$t('Telephone')"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userPhone"
              ></v-text-field>
              <v-text-field
                :label="$t('Email_label')"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="userInfo.userMail"
              ></v-text-field>
              <v-text-field
                label="Mesaj"
                v-model="userInfo.Message"
                textarea
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="sendEmail()">{{
              $t("Send")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import logoo from "../../../../../assets/control";
import helpers from "@/components/app/customcomp/helpers.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import axios from "axios";
import auth from "@/api/auth.js";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  props: {
    ticketList: {
      type: Array,
    },
    FlightType: {
      type: String,
    },
    isActive: {
      type: Boolean,
    },
  },
  components: {
    loadingcomp,
  },
  data() {
    return {
      loadingvmodel: false,
      otherPricesList: [],
      otherPrices: false,
      dialogAds: false,
      headersSummary: [
        {
          text: this.$t("Airline"),
          sortable: false,
        },
        {
          text: this.$t("Flight"),
          sortable: false,
        },
        {
          text: this.$t("Departure-TWO"),
          sortable: false,
        },
        {
          text: this.$t("Arrival"),
          sortable: false,
        },
        {
          text: this.$t("Plane-Type"),
          sortable: false,
        },
        {
          text: this.$t("Cabin"),
          sortable: false,
        },
        {
          text: this.$t("Seat"),
          sortable: false,
        },
      ],
      headers: Airports.headersSummary(),
      ticketMarkup: 0,
      openedPanel: null,
      cardView: false,
      tableView: false,
      allocated: Airports.allocateParams(),
      allocateItems: Airports.allocateItems(),
      userInfo: {
        userName: null,
        userPhone: null,
        userMail: null,
        Message: null,
      },
      dialogUserInfo: false,
      upSellTicket: {},
      isUpSell: false,
    };
  },
  methods: {
    setUpSellTicket(ticket) {
      this.isUpSell = true;
      this.upSellTicket = ticket;
      this.cardView = true;
    },
    openInfoDialog() {
      this.dialogAds = false;
      this.dialogUserInfo = true;
      var userInfo = JSON.parse(
        window.localStorage.getItem("WebUserManageLoad")
      );
      this.userInfo.userPhone = userInfo.UserInfo.GSM;
      this.userInfo.userName = userInfo.UserInfo.AdSoyad;
      this.userInfo.userMail = userInfo.UserInfo.Email;
    },
    sendEmail() {
      if (this.$refs.userInfoForm.validate()) {
        let formData = new FormData();
        var mailText =
          "Kullanici Adi = " +
          this.userInfo.userName +
          " | Telefon = " +
          this.userInfo.userPhone +
          " | Mail =  " +
          this.userInfo.userMail +
          " | Mesaj = " +
          this.userInfo.Message +
          " ";

        formData.append("Konu", "Sem Bilet Arkman Entegrasyon Talebi");
        formData.append("to", "demirarkman@arkman.com.tr");
        formData.append("formattedMessage", mailText);
        formData.append("mailType", "0");
        axios.defaults.baseURL = auth.API_URL;
        axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        axios
          .post(auth.API_URL + "api/Helpers/SendEmail", formData, {
            headers: {},
          })
          .then((response) => {
            if (response.data == true) {
              this.dialogUserInfo = false;
            }
          })
          .catch(function () {});
      }
    },
    openMailDialog() {
      this.dialogAds = true;
    },
    moneyformat(m) {
      if (m != 0) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      } else {
        return 0;
      }
    },
    checkTransfer(val) {
      let controlValue = 0;
      val.forEach((element) => {
        if (element.IsConnected || element.IsConnectedPreviousSegment) {
          controlValue++;
        }
      });
      if (controlValue != 0) {
        return true;
      } else {
        false;
      }
    },
    checkDirect(val) {
      let controlValue = 0;
      val.forEach((element) => {
        if (element.IsConnected || element.IsConnectedPreviousSegment) {
          controlValue++;
        }
      });
      if (controlValue == 0) {
        return true;
      } else {
        false;
      }
    },
    calculateFooter(type, ticketIndex) {
      // type 1 : BaseFare , 2: TotalTax , 3: ServiceFee , 4 : PassengerTypeQuantity , 5:TotalFare
      switch (type) {
        case 1:
          var _totalBaseFare = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalBaseFare = _totalBaseFare + element.BaseFare;
            }
          );
          return _totalBaseFare;
        case 2:
          var _totalTax = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalTax = _totalTax + element.TotalTax;
            }
          );
          return _totalTax;
        case 3:
          var _totalServiceFee = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalServiceFee = _totalServiceFee + element.ServiceFee;
            }
          );
          return _totalServiceFee;
        case 4:
          var _totalPassengerTypeQuantity = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalPassengerTypeQuantity =
                _totalPassengerTypeQuantity + element.PassengerTypeQuantity;
            }
          );
          return _totalPassengerTypeQuantity;
        case 5:
          var _totalTotalFare = 0;
          this.ticketList[ticketIndex].PricingInfo.FareBreakdowns.forEach(
            (element) => {
              _totalTotalFare = _totalTotalFare + element.TotalFare;
            }
          );
          return _totalTotalFare;

        default:
          break;
      }
    },
    formatDate(date) {
      var dateArray = date.split(" ");
      return dateArray[0];
    },
    ConvertTimeUnit(unit) {
      return unit == "HOUR" ? "saat" : unit;
    },
    ConvertTimePeriodCondition(period) {
      switch (period) {
        case "LESS":
          return "az";
        case "MORE":
          return "fazla";
        default:
          return period;
      }
    },
    calculateTimediff(val, type) {
      var start = null;
      var end = null;

      switch (val.length) {
        case 2:
          start = val[0].ArrivalDateTime;
          end = val[val.length - 1].DepartureDateTime;
          break;
        case 3:
          start = val[1].ArrivalDateTime;
          end = val[val.length - 1].DepartureDateTime;
          break;
        case 4:
          if (type == 1) {
            start = val[0].ArrivalDateTime;
            end = val[1].DepartureDateTime;
          } else {
            start = val[2].ArrivalDateTime;
            end = val[3].DepartureDateTime;
          }

          break;
        case 6:
          if (type == 5) {
            start = val[0].ArrivalDateTime;
            end = val[2].DepartureDateTime;
          } else {
            start = val[3].ArrivalDateTime;
            end = val[5].DepartureDateTime;
          }
          break;
        default:
          break;
      }

      let startDate = new Date(start);
      let endDate = new Date(end);
      let hours = parseInt(
        (Math.abs(endDate - startDate) / (1000 * 60 * 60)) % 24
      );
      let minutes = parseInt(
        (Math.abs(endDate.getTime() - startDate.getTime()) / (1000 * 60)) % 60
      );

      // If using time pickers with 24 hours format, add the below line get exact hours
      if (hours < 0) {
        hours = hours + 24;
      }
      if (type == 1) {
        if (hours == 0) {
          return minutes + " dakika";
        } else if (minutes == 0) {
          return hours + " saat ";
        } else {
          return hours + " sa " + minutes + " dk";
        }
      } else {
        return (
          (hours <= 9 ? "0" : "") +
          hours +
          ":" +
          (minutes <= 9 ? "0" : "") +
          minutes
        );
      }
    },
    calculateHourAndMinute(value) {
      var hours = value / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (rhours == 0) {
        return rminutes + " dakika";
      } else if (rminutes == 0) {
        return rhours + " saat ";
      } else {
        return rhours + " sa " + rminutes + " dk";
      }
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    getOtherPrices(index) {
      this.loadingvmodel = true;
      this.allocated = Airports.allocateParams();

      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      var ticket = this.ticketList[index];

      this.allocated.SessionHeader.SessionId = bookingParams.SessionId;
      this.allocated.SessionHeader.SessionToken = bookingParams.SessionToken;
      if (ticket.FlightSegments.length > 1) {
        let allocateFirstParams = {
          ProductId: ticket.FlightSegments[0].ProductId,
          FareCode: ticket.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);

        let allocateLastParams = {
          ProductId:
            ticket.FlightSegments[ticket.FlightSegments.length - 1].ProductId,
          FareCode: ticket.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);
      } else {
        this.allocateItems.ProductId = ticket.Id;
        this.allocateItems.FareCode = ticket.PricingInfo.FareReferenceId;
        this.allocateItems.MarkupFare = this.ticketMarkup;

        this.allocated.AllocateItems.push(this.allocateItems);
      }

      this.$http.post(auth.BOOKING_API_URL + "Air/Upsell", this.allocated).then(
        (response) => {
          if (!response.body.HasError) {
            this.otherPricesList = response.body.OriginDestinationOptions;
                        this.loadingvmodel = false;

          } else {
            this.text1 = response.body.ServiceError.ErrorMessages[0];
            this.snackbar = true;
            this.loadingvmodel = false;
            this.snackbarkColor = "warning";
          }
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-Air/Allocate";
            this.snackbar = true;
            this.loadingvmodel = false;
          } else {
            this.text1 = "Service Unavailable-Air/Allocate";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        }
      );
      window.localStorage.setItem(
        "allocateParams",
        JSON.stringify(this.allocated)
      );
    },
    pickTicket(ticket) {

      this.allocated = Airports.allocateParams();

      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );

      this.allocated.SessionHeader.SessionId = bookingParams.SessionId;
      this.allocated.SessionHeader.SessionToken = bookingParams.SessionToken;
      if (ticket.FlightSegments.length > 1) {
        let allocateFirstParams = {
          ProductId: ticket.FlightSegments[0].ProductId,
          FareCode: ticket.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);

        let allocateLastParams = {
          ProductId:
            ticket.FlightSegments[ticket.FlightSegments.length - 1].ProductId,
          FareCode: ticket.PricingInfo.FareReferenceId,
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);
      } else {
        this.allocateItems.ProductId = ticket.Id;
        this.allocateItems.FareCode = ticket.PricingInfo.FareReferenceId;
        this.allocateItems.MarkupFare = this.ticketMarkup;

        this.allocated.AllocateItems.push(this.allocateItems);
      }

      window.localStorage.setItem("flightType", this.FlightType);

      window.localStorage.setItem(
        "allocateParams",
        JSON.stringify(this.allocated)
      );

      var url = "#/satis/ucus/islem/id?islem=new";
      window.open(url, "_self");
    },
    openPanelProccess(type, index) {
      switch (parseInt(type)) {
        case 1:
          this.cardView ? (this.cardView = false) : (this.cardView = true);
          this.tableView = false;
          this.isUpSell = false;
          this.otherPrices = false;
          this.ticketMarkup = 0;
          break;
        case 2:
          this.tableView ? (this.tableView = false) : (this.tableView = true);
          this.otherPrices = false;
          this.cardView = false;
          break;
        case 3:
          if (this.otherPrices) {
            this.otherPrices = false;
          } else {
            this.otherPrices = true;
            this.getOtherPrices(index);
          }
          this.tableView = false;
          this.cardView = false;
          break;
      }
    },
    openPanel(index, type, value) {
      //type 1: card view 2: detail view 3:other prices

      if (this.openedPanel == index) {
        this.openPanelProccess(type, index);
      } else {
        this.openPanelProccess(type, index);
        this.openedPanel = index;
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style scoped>
.openCardListTile {
  height: auto;
  white-space: normal;
  overflow: visible;
}
</style>